// Mirrors mealz-api's isOpenAt(): close before open ends the next day; equal times mean open all day.
// Both times are HH:MM(:SS) strings, so they compare as text.
export const closesNextDay = (openTime: string, closeTime: string): boolean =>
  openTime !== '' && closeTime !== '' && closeTime < openTime
